import { supabase } from "..";
import { toast } from "react-toastify";
import {
  makeThreeAttempts,
  showMessagePayment,
  stripeAppearance,
  toastobj,
} from "../commonutilities";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import {
  CardElement,
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import {
  createStripeSubscription,
  updateStripePaymentId,
} from "../services/paymentService";
import { Backdrop, CircularProgress, FormGroup } from "@mui/material";
import { website_url } from "../bootapi";
import { Col, Input, Label, Row, Toast } from "reactstrap";

export const CheckoutForm = ({
  customer,
  user_id,
  token,
  setloader,
  refreshtoken,
  customer_id,
  customerData,
  uuid,
  giftCoupon,
}) => {
  const stripe = useStripe();
  const history = useNavigate();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  const [succeeded, setSucceeded] = useState(false);
  const [processing, setProcessing] = useState("");
  const [newloader, setnewloader] = useState(true);

  const checkSuccessSub = async (sub_id, user_id, token) => {
    const result = await makeThreeAttempts(sub_id, user_id, token);

    if (result === false) {
      // console.log("Failed after three attempts");
      history(`/auth/account_subscription`);
    } else {
      // console.log("Success");
      const responseData = result.data;
      if (responseData?.Subscriptions?.transaction_id) {
        history(
          `/auth/thank-you/${responseData?.Subscriptions?.transaction_id}${
            responseData?.Subscriptions?.with_free_trial ? "/freetrial" : ""
          }`,
          {
            state: {
              totalAmount: responseData?.Subscriptions?.total_amount,
            },
          }
        );
      } else {
        history(`/auth/account_subscription`);
      }
    }
  };

  useEffect(() => {
    if (!stripe) return;
    const clientSecret = new URLSearchParams(window.location.search).get(
      "setup_intent_client_secret"
    );
    // console.log(clientSecret);
    if (clientSecret) {
      setloader(true);

      stripe.retrieveSetupIntent(clientSecret).then((res) => {
        if (res["setupIntent"]) {
          let data = {
            payment_method: res["setupIntent"]["payment_method"],
            customer: customer_id,
            user_id,
          };
          updateStripePaymentId(data, token)
            .then((response) => {
              if (response.data.status) {
                toast.success("Success! Payment Method Updated", toastobj);
                let stripedetail = JSON.parse(
                  localStorage.getItem("stripe_details")
                );
                if (stripedetail?.["total_amount"]) {
                  localStorage.removeItem("stripe_details");
                }
                // console.log(customerData);
                deleteTempData();
              } else {
                setloader(false);
                toast.error("Error! Something Went Wrong", toastobj);
              }
            })
            .catch((err) => {
              setloader(false);
              toast.error(`${err?.response?.data?.message}`, toastobj);
            });
        }
      });
    } else {
      setloader(false);
    }
  }, [stripe]);
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    setProcessing(true);
    toast.info("Please wait!! We are updating your payment method", toastobj);
    const payload = await stripe.confirmSetup({
      elements,
      confirmParams: {
        // return_url: `http://localhost:3000/auth/freeTrialGift/${refreshtoken}/${customer_id}/${uuid}`,
        return_url: `${website_url}/auth/freeTrialGift/${refreshtoken}/${customer_id}/${uuid}`,
      },
    });
    // const payload = await stripe.confirmCardSetup(clientsecret, {
    //   payment_method: {
    //     card: elements.getElement(CardElement),
    //   },
    // });
    if (payload.error) {
      toast.error(`Payment failed ${payload.error.message}`, toastobj);
      setProcessing(false);
      setloader(false);
    } else {
      setProcessing(false);
      setSucceeded(true);
    }
  };
  useEffect(() => {
    if (elements) {
      const element = elements.getElement("payment");
      element.on("ready", () => {
        setnewloader(false);
        // console.log('Ready');
      });
    }
  }, [elements]);

  const deleteTempData = async () => {
    const { error } = await supabase
      .from("subs_temsubscription")
      .delete()
      .eq("unique_key", uuid);
    if (error) {
      setloader(false);
      toast.error("Somthing went wrong");
    } else {
      let tempObject = customerData;
      tempObject.customer_id = customer_id;
      const formData = new FormData();
      formData.append("data", JSON.stringify(tempObject));
      createStripeSubscription(formData, token)
        .then((res) => {
          if (res.data.status) {
            checkSuccessSub(
              res.data.subscription.subscription_id,
              user_id,
              token
            );
            /* setTimeout(() => {
              setloader(false);
              history("/auth/account_subscription");
            }, [2000]); */
          }
        })
        .catch((error) => {
          setloader(false);
          toast.error(` ${error?.response?.data?.message}`);
        });
    }
  };

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={newloader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Row>
        <Col md={5}>
          <form onSubmit={handleSubmit}>
            {/* <CardElement id="card-element" options={cardStyle} /> */}
            <PaymentElement />
            <div className="mt-4 d-flex cg-1 justify-content-between">
              <button
                type="button"
                className="btn btn-primary"
                style={giftCoupon ? {} : { visibility: "hidden" }}
                onClick={() => {
                  window.history.back();
                }}
              >
                Go Back
              </button>
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => {
                  setloader(true);
                  deleteTempData();
                }}
              >
                Add Card Later
              </button>
              <button disabled={!stripe} className="btn btn-primary">
                {processing ? (
                  <div className="spinner" id="spinner"></div>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
            {errorMessage && <div className="text-danger">{errorMessage}</div>}
            <p
              className={succeeded ? "result-message" : "result-message hidden"}
            >
              Card Update succeeded, see the result in your
              <a href={`https://dashboard.stripe.com/test/payments`}>
                {" "}
                Stripe dashboard.
              </a>{" "}
            </p>
          </form>
        </Col>
      </Row>
    </div>
  );
};

const StripeFreeTrialGiftCard = (args) => {
  const location = useLocation();
  let messagesEndRef = useRef(null);
  let [user, setuser] = useState({});
  const { refresh_session, customer_id, uuId } = useParams();
  const [loader, setloader] = useState(false);
  const [amount, setAmount] = useState();
  const [options, setoptions] = useState({});
  const [showform, setshowform] = useState(false);
  const [refreshtoken, setrefreshtoken] = useState("");
  const [token, setToken] = useState("");
  const [stripepromise, setstripepromise] = useState();
  const [customerData, setCustomerData] = useState(null);
  const { giftCouponVerified } = location.state || {};
  const { typeOfSub } = location.state || {};
  const { amountOfSub } = location.state || {};
  const [stateGiftCouponVerified, setStateGiftCouponVerified] = useState(false);
  const [isFreeTrial, setIsFreeTrial] = useState();
  const [firstZeroGift, setFirstZeroGift] = useState(false);

  useEffect(() => {
    const getcustomerid = () => {
      setloader(true);
      supabase.auth.getSession().then((res) => {
        if (
          res.data.session &&
          res.data.session.user &&
          res.data.session.user.id
        ) {
          setuser(res.data.session.user);
          setrefreshtoken(res.data.session.refresh_token);
          setToken(res.data.session.access_token);
          getsubscription(
            res.data.session.user.id,
            res.data.session.access_token
          );
        }
      });
    };

    getcustomerid();
  }, []);
  useEffect(() => {
    // Check if giftCouponVerified is true and perform actions
    // console.log(giftCouponVerified);
    if (giftCouponVerified) {
      setStateGiftCouponVerified(true);
    }
  }, [giftCouponVerified]);
  const getsubscription = async (id, token) => {
    if (customer_id) {
      let { data, error } = await supabase
        .from("subs_temsubscription")
        .select("*")
        .eq("unique_key", uuId);
      if (data) {
        let tempdata = JSON.parse(data[0]?.json);
        if (tempdata?.freeTrial) {
          setIsFreeTrial(tempdata?.freeTrial);
          trackBeginCheckout(0);
        }
        if (tempdata?.firstZeroGift) {
          setFirstZeroGift(tempdata?.firstZeroGift);
        }

        // console.log(tempdata);

        setCustomerData(tempdata?.data);

        setoptions({
          clientSecret: tempdata?.paymentDetails?.client_secret?.client_secret,
          appearance: stripeAppearance,
        });

        setstripepromise(loadStripe(tempdata?.paymentDetails?.publishableKey));
        setTimeout(() => {
          setloader(false);
          // scrollToBottom();
          setshowform(true);
        }, 2000);
      }
      //   callstripeapi(customer_id, id, token);
    }
  };
  const trackBeginCheckout = (totalPrice) => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-11164611927/AonOCPnn1osZENfq2csp",
        value: totalPrice,
        currency: "USD",
      });
    }
  };

  return (
    <div
      onClick={() => {
        args.toggleMenu();
      }}
      style={window.innerWidth < 600 ? { marginBottom: "5rem" } : {}}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {showform && options["clientSecret"] && (
        <div
          ref={messagesEndRef}
          className="container"
          style={{ marginTop: "100px" }}
        >
          <Row style={{ marginBottom: "1rem" }}>
            <Col md={5}>
              <h3 className={`${stateGiftCouponVerified ? "mb-0" : "mb-4"}`}>
                Payment Method
              </h3>
              {stateGiftCouponVerified && (
                <>
                  {/*  <h4 style={{ marginBottom: "0" }}>
                    Please update payment method to complete your subscriptions.
                  </h4> */}
                  <p className="text-primary mt-1 mb-4">
                    (You wont be charged now{" "}
                    {!firstZeroGift && isFreeTrial?.days
                      ? `,you will be charged after ${isFreeTrial?.days} days`
                      : `,you will be charged after 1 ${typeOfSub}`}{" "}
                    )
                  </p>
                </>
              )}

              <FormGroup>
                <Label>Amount</Label>
                <Input
                  // placeholder="15- March - 1985"
                  className="new-stripe-input"
                  type="text"
                  value={`$${amount ? amount : 0}`}
                  readOnly
                  disabled
                  style={{ color: "white" }}

                  // onChange={(e) => setBirthDate(e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Elements stripe={stripepromise} options={options}>
            <CheckoutForm
              customer={user["customer"]}
              user_id={user["id"]}
              setloader={setloader}
              refreshtoken={refreshtoken}
              token={token}
              customer_id={customer_id}
              uuid={uuId}
              customerData={customerData}
              giftCoupon={stateGiftCouponVerified}
            />
          </Elements>
        </div>
      )}
    </div>
  );
};

export default StripeFreeTrialGiftCard;
